import * as React from "react";
const SvgFiRrBookArrowUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-book-arrow-up_svg__a)">
      <path d="M22.293 15.895 21 14.602V23c-.006 1.308-1.995 1.307-2 0v-8.398l-1.293 1.293a.999.999 0 1 1-1.414-1.414l1.613-1.614a2.965 2.965 0 0 1 4.187 0l1.614 1.614c.921.928-.486 2.335-1.414 1.414" />
      <path d="M17 0H7a5 5 0 0 0-5 5v15a4 4 0 0 0 4 4h10c1.308-.006 1.307-1.995 0-2H6a2.003 2.003 0 0 1-1.972-2.338C4.19 18.678 5.116 18 6.113 18h7.888c1.308-.006 1.307-1.995 0-2h-6V2h9a3 3 0 0 1 3 3v4c.006 1.308 1.994 1.307 2 0V5c0-2.761-2.24-5-5.001-5M6 16c-.732 0-1.409.212-2 .556V5c0-1.302.839-2.402 2-2.816z" />
    </g>
    <defs>
      <clipPath id="fi-rr-book-arrow-up_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBookArrowUp;
